import { StandardReducerImpl, StandardState } from 'reducers/standard.reducer';
import { Article, defaultArticle } from 'model/dealer/article.model';

const entity = 'Article';
const apiUrl = '/api/yumei-mall-post/article';
const standardReducerImpl = new StandardReducerImpl<Article>(entity, defaultArticle, apiUrl);
export type ArticleState = StandardState<Article>;
export const article = standardReducerImpl.buildStandardReducer();

export const getEntities = standardReducerImpl.getEntities;
export const getEntity = standardReducerImpl.getEntity;
export const createEntity = standardReducerImpl.createEntity;
export const updateEntity = standardReducerImpl.updateEntity;
export const deleteEntity = standardReducerImpl.deleteEntity;
export const reset = standardReducerImpl.reset;

